import { render, staticRenderFns } from "./SubNav.vue?vue&type=template&id=cc8058aa&scoped=true&"
import script from "./SubNav.vue?vue&type=script&lang=js&"
export * from "./SubNav.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/sub-nav.scss?vue&type=style&index=0&id=cc8058aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8058aa",
  null
  
)

export default component.exports